import Cookie from 'js-cookie';
import helpers from './helpers.js';

/*
===================================================================
Notice block to set cookies
===================================================================
*/
export default (function () {
  return {
    init() {
      const cookieSetters = document.querySelectorAll('.js-cookie-setter');

      if (cookieSetters.length) {
        helpers.forEach(cookieSetters, (i, val) => {
          const cookieElement = val;

          cookieElement.addEventListener('click', (e) => {
            e.preventDefault();
            const name = cookieElement.getAttribute('data-notice-name');
            const value = cookieElement.getAttribute('data-notice-value');
            const expires = parseInt(cookieElement.getAttribute('data-notice-duration'), 10) || null;

            // console.log(name, value, expires);
            Cookie.set(
              name,
              value,
              {
                secure: true,
                expires,
              },
            );

            const notice = cookieElement.closest('.notice-block');
            if (notice != null) {
              notice.parentNode.removeChild(notice);
            }
          });
        });
      }
    },
  };
}());
